'use strict';

const profileConfigRoutes = {
    en: {
        ActorProfile:               "/:language/amateur/:actorName/*",

        ActorProfileOverview:       "/",
        ActorProfileAboutMe:        "/about-me/",

        ActorProfileVideos:         "/videos/",
        ActorProfileVideosTagGroup: "/videos/tag/:tagGroup/",
        ActorProfileClassicVideos:  "/videos/classic/",
        ActorProfileVideoDetails:   "/videos/:videoId/",

        ActorProfilePhotos:         "/pictures/",
        ActorProfilePhotosDetails:  "/pictures/:photoId/",

        ActorProfileTopCams:        "/top-cams/",
        ActorProfileLiveShow:       "/live-show/"
    },
    de: {
        ActorProfile:               "/:language/amateur/:actorName/*",

        ActorProfileOverview:       "/",
        ActorProfileAboutMe:        "/ueber-mich/",

        ActorProfileVideos:         "/videos/",
        ActorProfileVideosTagGroup: "/videos/tag/:tagGroup/",
        ActorProfileClassicVideos:  "/videos/classic/",
        ActorProfileVideoDetails:   "/videos/:videoId/",

        ActorProfilePhotos:         "/fotos/",
        ActorProfilePhotosDetails:  "/fotos/:photoId/",

        ActorProfileTopCams:        "/top-cams/",
        ActorProfileLiveShow:       "/live-show/"
    },
    es: {
        ActorProfile:               "/:language/amateur/:actorName/*",

        ActorProfileOverview:       "/",
        ActorProfileAboutMe:        "/acerca-de-mi/",

        ActorProfileVideos:         "/videos/",
        ActorProfileVideosTagGroup: "/videos/tag/:tagGroup/",
        ActorProfileClassicVideos:  "/videos/classic/",
        ActorProfileVideoDetails:   "/videos/:videoId/",

        ActorProfilePhotos:         "/fotos/",
        ActorProfilePhotosDetails:  "/fotos/:photoId/",

        ActorProfileTopCams:        "/top-cams/",
        ActorProfileLiveShow:       "/show-en-vivo/"
    }
};



function ProfileRoutes (routesConfig, language) {
    this.routesConfig = routesConfig;
	this.language     = language;
}

ProfileRoutes.prototype.ACTOR_PROFILE          = 'ActorProfile';

ProfileRoutes.prototype.ACTOR_OVERVIEW         = 'ActorProfileOverview';
ProfileRoutes.prototype.ACTOR_ABOUT_ME         = 'ActorProfileAboutMe';

ProfileRoutes.prototype.ACTOR_VIDEOS           = 'ActorProfileVideos';
ProfileRoutes.prototype.ACTOR_VIDEOS_TAG_GROUP = 'ActorProfileVideosTagGroup';
ProfileRoutes.prototype.ACTOR_CLASSIC_VIDEOS   = 'ActorProfileClassicVideos';
ProfileRoutes.prototype.ACTOR_VIDEO_DETAILS    = 'ActorProfileVideoDetails';

ProfileRoutes.prototype.ACTOR_PHOTOS           = 'ActorProfilePhotos';
ProfileRoutes.prototype.ACTOR_PHOTOS_DETAILS   = 'ActorProfilePhotosDetails';

ProfileRoutes.prototype.ACTOR_TOP_CAMS         = 'ActorProfileTopCams';
ProfileRoutes.prototype.ACTOR_LIVESHOW         = 'ActorProfileLiveShow';



ProfileRoutes.prototype.getPathByName = function(routeName) {
	return Object.hasOwn(this.routesConfig, routeName) ? this.routesConfig[routeName] : '/this/is/not/a/route';
};



ProfileRoutes.prototype.getLink = function(routeName, params) {
	const link = this.routesConfig[routeName];

	if (!params) {
		params = {};
	}

	params[':language'] = this.language;

	if (!link) {
		/* eslint-disable */
		console.error('No link found for route:' + routeName);
		/* eslint-enable */
		return '';
	}

	return link.replace(/(:[A-Za-z0-9]+)\/?/g, function($1, $2) {
		return params[$2] + '/';
	}).toLowerCase();
};


export default new ProfileRoutes(profileConfigRoutes[window.VXConfig.language], window.VXConfig.language);
